import React, { useState } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../ApiConfig';
import style from "../../css/auth/Login_otp.module.css";
import { Link, useNavigate } from 'react-router-dom';
import { showCustomAlert, showCustomAlerterror } from '../customalert';
import GoogleLoginComponent from './GoogleLoginComponent';
import { getSecureToken } from '../ApisService/apiService';

const Login_otp = () => {
    const [formData, setFormData] = useState({
        mobileNumber: '',
        otp: '',
    });

    const [isSendingCode, setIsSendingCode] = useState(false);
    const [isVerifyingOTP, setIsVerifyingOTP] = useState(false);
    const [otpSent, setOtpSent] = useState(false);
    const [message, setMessage] = useState('');
    const [formErrors, setFormErrors] = useState({});
    const navigate = useNavigate();

    // Handle input change for mobile and OTP
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
        setMessage('');
        setFormErrors({});
    };

    // Validate mobile number format
    const validateMobile = () => {
        if (!formData.mobileNumber) {
            setFormErrors({ mobileNumber: 'Mobile Number is required' });
            return false;
        }
        if (!/^\d{10}$/.test(formData.mobileNumber)) {
            setFormErrors({ mobileNumber: 'Enter a valid 10-digit mobile number' });
            return false;
        }
        return true;
    };

    // ✅ function to check user
    const checkUserExists = async (mobile) => {


        if (!validateMobile()) return;

        const { secrettoken, ts } = await getSecureToken();

        try {
            const res = await axios.post(`${API_BASE_URL}auth/checkUserExists.php`, {
                mobileNumber: mobile,
            }, {
                headers: {
                    'Content-Type': 'application/json',
                    'X-TOKEN': secrettoken,
                    'X-TIMESTAMP': ts
                },
                withCredentials: true,
            });

            if (res.data.status === 'success') {

                sendOTP(mobile);
            } else {
                showCustomAlerterror("User not found. Please check the mobile number.");
                setIsSendingCode(false);
            }

        } catch (error) {
            console.error('Error checking user existence:', error);
            showCustomAlerterror('Something went wrong. Please try again.');
            setIsSendingCode(false);
        }
    };



    // Send OTP request
    const sendOTP = async (mobile) => {
        setIsSendingCode(true);
        const { secrettoken, ts } = await getSecureToken();
        try {
            const response = await axios.post(
                `${API_BASE_URL}sendOTP.php`,
                { mobileNumber: mobile },
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'X-TOKEN': secrettoken,
                        'X-TIMESTAMP': ts
                    },
                    withCredentials: true
                }
            );

            if (response.status === 200 && response.data.status === 'success') {
                setOtpSent(true);
                setMessage('OTP sent to your mobile number.');
            } else {
                showCustomAlerterror(`Error: ${response.data.message || 'Failed to send OTP.'}`);
            }
        } catch (error) {
            showCustomAlerterror('Error sending OTP. Please try again later.');
        } finally {
            setIsSendingCode(false);
        }
    };


    // Verify OTP request
    const verifyOTP = async () => {
        if (!formData.otp) {
            setFormErrors({ otp: 'Please enter OTP' });
            return;
        }
        setIsVerifyingOTP(true);
        const { secrettoken, ts } = await getSecureToken();
        try {
            const response = await axios.post(`${API_BASE_URL}auth/login_verify_otp.php`, {
                mobileNumber: formData.mobileNumber,
                otp: formData.otp,
            }, {
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json', 'X-TOKEN': secrettoken,
                    'X-TIMESTAMP': ts
                }
            });

            // console.log("Raw response", response);

            if (response.data.status === 'success') {
                showCustomAlert('OTP Verified! Login successful.');
                const data = response.data;
                localStorage.setItem('isuserlogin', 'true');
                localStorage.setItem('autoLoginEmail', data.email);
                localStorage.setItem('userEmail', data.email);
                localStorage.setItem('fullName', data.fullName);
                localStorage.setItem('mobilenumber', data.mobileNumber);
                localStorage.setItem('planexpire', data.subscription_date);

                setFormData({ email: '', password: '' });
                document.getElementById('login_otp_CloseBtn').click();

                setTimeout(() => {
                    setMessage('');
                }, 1000);

                setTimeout(() => {
                    navigate('/dashboard');
                }, 300);

            } else {
                setMessage(`OTP Verification Failed: ${response.data.message || 'Invalid OTP'}`);
                showCustomAlerterror(`OTP Verification Failed: ${response.data.message || 'Invalid OTP'}`);
            }

        } catch (error) {
            // console.log(`Error verifying OTP: ${error.response?.data?.message || error.message}`);
            showCustomAlerterror(`Error verifying OTP: ${error.response?.data?.message || error.message}`);
            // setMessage(`Error verifying OTP: ${error.response?.data?.message || error.message}`);

        } finally {
            setIsVerifyingOTP(false);
        }
    };
    const closeModal = () => {
        const closeBtn = document.getElementById('login_otp_CloseBtn');
        if (closeBtn) {
            closeBtn.click();
        }
    };
    return (
        <>
            <div
                className="modal"
                id="Login_otp_modal"
                tabIndex="-1"
                aria-labelledby="LoginOtpLabel"
                aria-hidden="true"
            >
                <div className={`modal-dialog  ${style.modal_dialog_box}`}>
                    <div className={`modal-content ${style.modelcontent_bg}`}>
                        <div className="modal-header">
                            <h5 className={`modal-title ${style.loginheading}`} id="LoginOtpLabel">
                                Welcome!
                            </h5>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                                id="login_otp_CloseBtn"
                            ></button>
                        </div>
                        <div className={`modal-body ${style.loginmodalbox}`}>
                            {message && (
                                <div
                                    className={`alert ${message.toLowerCase().includes('error') || message.toLowerCase().includes('failed')
                                        ? 'alert-danger'
                                        : 'alert-success'
                                        }`}
                                    role="alert"
                                >
                                    {message}
                                </div>
                            )}

                            <label className={style.signupcontent} htmlFor="mobileNumber">
                                Mobile Number
                                <div className={style.signupiconsWrapper}>
                                    <div className={style.inputWithIcon}>
                                        <i className={`fa-solid fa-phone ${style.signupIcon}`}></i>
                                        <input
                                            id="mobileNumber"
                                            className={style.signupmodalinputtxt}
                                            type="tel"
                                            name="mobileNumber"
                                            value={formData.mobileNumber}
                                            onChange={(e) => {
                                                const onlyDigits = e.target.value.replace(/\D/g, ''); // Remove non-digits
                                                if (onlyDigits.length <= 10) {
                                                    setFormData({ ...formData, mobileNumber: onlyDigits });
                                                }
                                            }}
                                            placeholder="Enter 10-digit mobile number"
                                            disabled={otpSent}
                                            maxLength={10}
                                        />

                                    </div>
                                    {!otpSent && (
                                        <button
                                            type="button"
                                            className={style.verifybtn}
                                            onClick={() => checkUserExists(formData.mobileNumber)}

                                            disabled={isSendingCode}
                                        >
                                            <i className="fa-solid fa-paper-plane"></i>&nbsp;
                                            {isSendingCode ? 'Sending...' : 'Verify'}
                                        </button>
                                    )}
                                </div>
                                {formErrors.mobileNumber && (
                                    <span className={`${style.error} text-danger`}>{formErrors.mobileNumber}</span>
                                )}
                            </label>


                            {otpSent && (
                                <label className={style.signupcontent} htmlFor="otp">
                                    Enter OTP
                                    <div className={style.signupiconsWrapper}>
                                        <div className={style.inputWithIcon}>
                                            <i className={`fa-solid fa-key ${style.signupIcon}`}></i>
                                            <input
                                                id="otp"
                                                className={style.signupmodalinputtxt}
                                                type="text"
                                                name="otp"
                                                value={formData.otp}
                                                onChange={handleInputChange}
                                                placeholder="Enter OTP"
                                                maxLength={6}
                                            />
                                        </div>
                                        <button
                                            type="button"
                                            className={`${style.verifybtn} btn btn-success`}
                                            onClick={verifyOTP}
                                            disabled={isVerifyingOTP}
                                        >
                                            <i className="fa-solid fa-right-to-bracket"></i>&nbsp;
                                            {isVerifyingOTP ? 'Verifying...' : 'Login'}
                                        </button>
                                    </div>
                                    {formErrors.otp && (
                                        <span className={`${style.error} text-danger`}>{formErrors.otp}</span>
                                    )}
                                </label>

                            )}

                            <div className="div">
                                <GoogleLoginComponent onLoginSuccess={closeModal} />
                            </div>

                            <div className="loginfooter d-flex justify-content-between mt-3">
                                <p className={style.footertextlogin} data-bs-dismiss="modal" aria-label="Close">
                                    Don't have an account?{' '}
                                    <Link to="Reg_pay" className="text-decoration-none">
                                        Get registered
                                    </Link>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Login_otp;
